import React from 'react'
import { useSelector } from 'react-redux'
import { getActiveSideForSectionSides, getAdditionalSectionsSides, getValueOption, getValueSideSectionOption, valueOption } from '../../store/selectors/selectors'
import { SelectGroupSide } from '../StandartComponent/SelectGroupSide/SelectGroupSide'
 //@ts-ignore
import s from './SideCheckViewSetting.module.scss'


export const SideCheckViewSetting = ({ ...props }) => {

    let { children, id } = props

    let sectionForSides: any = useSelector(getAdditionalSectionsSides);
    let ActiveSides: any = useSelector(getActiveSideForSectionSides);
    let { selectValue }: any = useSelector(getValueSideSectionOption('orientationSideView'));
    if (!!ActiveSides && ['SideC', 'SideA'].includes(ActiveSides['id'])) sectionForSides = sectionForSides.filter((section: any) => section['label'] !== 'Dormer')

    return (
        <div className={s.section}>
            <div className={s.header}>
                <div className={s.name}>{!!ActiveSides && ActiveSides['label']}</div>
                <div className={s.sides}>
                    <SelectGroupSide id={id} values={sectionForSides} selectValue={selectValue}  ></SelectGroupSide>
                </div>
            </div>
            <div className={s.main}>
                {children}
            </div>
        </div>
    )
}
